import { useCallback } from 'react';

export function useMergedRefs<T>(...refs: any[]) {
  return useCallback(
    (node: T) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref != null) {
          ref.current = node;
        }
      });
    },
    [refs]
  );
}
